import { all, call, put, takeLatest } from 'redux-saga/effects';
import { AxiosCall, AxiosPost } from '../../../utils/axios';
import * as actions from './actions';

function* fetchCourtesies() {
  try {
    const result = yield call(AxiosCall, '/payments/courtesies/');
    yield put(actions.fetchCourtesiesSuccess(result.data.response));
  } catch (e) {
    yield put(actions.fetchCourtesiesFailure(e));
  }
}

function* grantCourtesy(action) {
  try {
    const { user_email, perks, duration_days, reason } = action.payload;
    const result = yield call(AxiosPost, '/payments/grant_courtesy/', {
      user_email,
      perks,
      duration_days,
      reason,
    });
    yield put(actions.grantCourtesySuccess(result.data.response));
  } catch (e) {
    yield put(actions.grantCourtesyFailure(e));
  }
}

function* revokeCourtesy(action) {
  try {
    yield call(AxiosPost, '/payments/revoke_courtesy/', {
      courtesy_id: action.payload,
    });
    yield put(actions.revokeCourtesySuccess(action.payload));
  } catch (e) {
    yield put(actions.revokeCourtesyFailure(e));
  }
}

export default function* courtesiesSaga() {
  yield all([
    takeLatest(actions.FETCH_COURTESIES_REQUEST, fetchCourtesies),
    takeLatest(actions.GRANT_COURTESY_REQUEST, grantCourtesy),
    takeLatest(actions.REVOKE_COURTESY_REQUEST, revokeCourtesy),
  ]);
}
